/**
 * 반응형 폰트 크기 생성기
 * @param {number} minPx - 최소 폰트 크기(px)
 * @param {number} maxPx - 최대 폰트 크기(px)
 * @param {number} minVw - 최소 화면 너비(px)
 * @param {number} maxVw - 최대 화면 너비(px)
 * @returns {string} clamp() 문자열
 */
export const fluidFont = (minPx, maxPx, minVw = 320, maxVw = 1920) => {
  const slope = ((maxPx - minPx) / (maxVw - minVw)) * 100; // vw 단위 변환
  const yAxisIntercept = minPx - (slope / 100) * minVw;
  return `clamp(${minPx}px, ${yAxisIntercept}px + ${slope}vw, ${maxPx}px)`;
};
